import { all, put, takeEvery, select } from "redux-saga/effects";
import { sendAlert } from "../actions/alerts";
import { receiveLogin } from "../actions/auth";
import { syncDeviceLocation } from "../actions/forms";
import { SIGN_IN_FIREBASE } from "../actions/auth";

import fireapi from "../../utils/firebaseapi";
export const getIsLogin = (state) => state.authReducer.isLogin;

export function* loginSaga(action) {
  console.log("loginSaga");
  console.log(action);
  try {
    let isLogged = yield select(getIsLogin);
    console.log({ isLogged });
    if (isLogged) {
      yield put(syncDeviceLocation());
    } else {
      let response = yield fireapi.doSignInWithPoppup();
      yield put(syncDeviceLocation());
      yield put(receiveLogin(response));
    }
    action.payload.navigate("/upload");
  } catch (error) {
    console.log(error);
    const severity = "error";
    const title = "Firebase";
    const content = "error connection";
    yield put(sendAlert({ severity, title, content }));
  }
}

export default function* loginRootSaga() {
  yield all([takeEvery(SIGN_IN_FIREBASE, loginSaga)]);
}
